import React from 'react'
import { BackButton } from '../Components/Simple';
import EobComponent from '../Components/Combined/EobComponent';
import { Navigate, useLocation }  from 'react-router-dom';
import { format } from 'date-fns';

function generateClaimId(date) {
    if (!date) {
        return null;
    }

    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let uid = '';
    for (let i = 0; i < 5; i++) {
        uid += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }

    return `${format(date, "yyyy-MMddHH")}-${uid}`;
}

export default function EobGenerator() {
    const location = useLocation();

    if (!location.state) {
        console.warn('No location state is found. Going back Home.  The user probably got here out of band somehow.');
        return <Navigate to="/" />
    }

    const claimId = generateClaimId(location.state?.processedDate);

    return (
        <div className="py-2">
            <div className="row my-2 justify-content-between sticky top g-0 border-bottom align-items-center">
                <div className="col-auto">
                    <h3>EOB Generator</h3>
                    <div className="fs-6">
                        Fill in the information that is required to generate the EOB, then submit.
                    </div>
                </div>
                <div className="col-auto">
                    <BackButton />
                </div>
            </div>
            <EobComponent id="eobComponent" claimId={claimId} lines={location.state.lines} processedDate={location.state.processedDate} pricerType={location.state.pricerType} />
        </div>
    )
};
